// extracted by mini-css-extract-plugin
export default {"hideTooltip":"jta-z","fadeIn":"kta-z","delay":"lta-z","recommendedSizeTooltip":"mta-z"};